// Generated by ReScript, PLEASE EDIT WITH CARE


function stringToVariant(str, data) {
  switch (str) {
    case "Both" :
        return {
                TAG: /* Both */2,
                _0: data
              };
    case "Drop" :
        return {
                TAG: /* Drop */1,
                _0: data
              };
    case "Pickup" :
        return {
                TAG: /* PickUp */0,
                _0: data
              };
    default:
      return /* None */0;
  }
}

export {
  stringToVariant ,
  
}
/* No side effect */
